import { render, staticRenderFns } from "./TopTag.vue?vue&type=template&id=729d827c&scoped=true&"
import script from "./TopTag.vue?vue&type=script&lang=ts&"
export * from "./TopTag.vue?vue&type=script&lang=ts&"
import style0 from "./TopTag.vue?vue&type=style&index=0&id=729d827c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d827c",
  null
  
)

export default component.exports